var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Settings","doc":_vm.doc}},[_c('div',{staticClass:"s-vstack"},[_c('v-col',{attrs:{"align":"center"}},[_c('ProfilePicture',{attrs:{"enterprise":_vm.enterprise}})],1),_c('Profile'),_c('Access')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }